import { render, staticRenderFns } from "./logo-colored.vue?vue&type=template&id=0b670543&scoped=true&"
import script from "./logo-colored.vue?vue&type=script&lang=js&"
export * from "./logo-colored.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b670543",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage})
